import { Button, Form, Input, Typography, message as messages } from "antd";
import { AppLogoIcon } from "components/svg-icons";
import { ErrorMessages, Regex } from "constants/index";
import FormItem from "antd/es/form/FormItem";
import { ChangePasswordRequest } from "models/user";
import { useEffect, useState } from "react";
import { changeExpiredPassword, getAccessToken } from "services/auth";
import { useHistory } from "react-router";
import PasswordPolicy, {
  ExpiredPasswordPolicyAlert,
  PasswordFailedConditionsAlert
} from "components/widgets/auth-widgets/password-policy";

function ChangePasswordOnExpiry() {
  const [form] = Form.useForm();
  const { Title } = Typography;
  const history = useHistory();

  const [loader, setLoader] = useState(false);

  const [passwordHasConditionsError, setPasswordHasConditionsError] =
    useState(false);

  useEffect(() => {
    const token = getAccessToken();
    if (!token) {
      history.push("/");
    }
  }, [history]);

  const onFinish = async (event: ChangePasswordRequest) => {
    setLoader(true);
    const result: any = await changeExpiredPassword({
      new_password: event.new_password,
      from_expiry: true
    });

    setLoader(false);
    if (result.status >= 200 && result.status <= 204) {
      setLoader(false);
      messages.success(ErrorMessages.PasswordSetMsg);
      history.push("/");
    } else if (result.response?.data?.error) {
      messages.error(result.response?.data.error);
      if (result.response?.data?.error === "Link has expired.") {
        history.push("/");
      }
    } else {
      messages.error(result.message);
    }

    form.resetFields();
  };

  const onFinishFailed = () => {
    const passwordFieldErrors = form.getFieldError("new_password");
    if (passwordFieldErrors.length > 0) {
      setPasswordHasConditionsError(true);
    } else {
      setPasswordHasConditionsError(false);
    }
  };

  const onValuesChange = () => {
    form.validateFields(["new_password"]).catch((err) => {
      if (err.errorFields.length > 0 && err.values.new_password) {
        setPasswordHasConditionsError(true);
      } else {
        setPasswordHasConditionsError(false);
      }
    });
  };

  return (
    <div className="flex flex-col h-[90vh]">
      <div className="flex bg-ciq-neutral-50 items-center justify-center h-full w-full">
        <div className="flex flex-col p-8 shadow-[0px_5px_25px_rgba(0,0,0,0.1)] w-[400px] rounded-md">
          <div className="m-auto block">
            <AppLogoIcon />
          </div>
          <div className="flex justify-center">
            <Title level={3}>Reset Password</Title>
          </div>
          <div className="pt-2 pb-4 space-y-3">
            {passwordHasConditionsError && (
              <PasswordFailedConditionsAlert className="mt-1 mb-2" />
            )}
            <ExpiredPasswordPolicyAlert />
            <PasswordPolicy />
          </div>
          <Form
            className="space-y-3"
            onFinish={onFinish}
            form={form}
            scrollToFirstError
            layout="vertical"
            onFinishFailed={onFinishFailed}
            onValuesChange={onValuesChange}
          >
            <FormItem
              name="new_password"
              label="New Password"
              validateStatus=""
              rules={[
                {
                  validateTrigger: "onChange",
                  required: true,
                  pattern: Regex.password
                }
              ]}
              className="hide-ant-field-error-msg"
            >
              <Input.Password placeholder="Enter New Password" />
            </FormItem>

            <FormItem
              name="confirmpassword"
              label="Confirm New Password"
              dependencies={["new_password"]}
              hasFeedback
              validateStatus=""
              rules={[
                {
                  required: true,
                  validateTrigger: "onChange",
                  message: ErrorMessages.ConfirmPasswordRequired
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(ErrorMessages.ConfirmPasswordRequired)
                    );
                  }
                })
              ]}
            >
              <Input.Password placeholder="Enter New Password" />
            </FormItem>
            <div style={{ paddingTop: "1em" }}>
              <Button
                htmlType="submit"
                size="middle"
                style={{ margin: "auto", display: "block" }}
                loading={loader}
              >
                Submit
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}
export default ChangePasswordOnExpiry;
